const cache=new Map();
export const ratingWord=rating=>rating>=4.5?'Excellent':rating>=4?'Très bien':rating>=3?'Moyen':rating>=2?'Passable':'Insuffisant';
export function parseAggregate(data){
  const a=data?.reviewAggregate;
  if(!a)return null;
  const count=Number(a.reviewCount),total=Number(a.reviewRatingValuesTotal);
  if(!Number.isInteger(count)||count<=0||!Number.isFinite(total)||total<count||total>count*5)return null;
  return {count,rating:total/count};
}
export async function getAggregate(store,fetcher=fetch){
  if(!/^[a-f\d-]{36}$/i.test(store||''))return null;
  const r=await fetcher(`https://api.okendo.io/v1/stores/${store}/review_aggregate`,{credentials:'omit',signal:AbortSignal.timeout(12000)});
  if(!r.ok)throw new Error('Review totals unavailable');
  return parseAggregate(await r.json());
}
export async function connectAggregate(root){
  if(root.dataset.summaryStarted)return;
  root.dataset.summaryStarted='true';
  const store=root.dataset.store;
  if(!cache.has(store))cache.set(store,getAggregate(store).catch(error=>{cache.delete(store);throw error}));
  let stats;try{stats=await cache.get(store)}catch{delete root.dataset.summaryStarted;return}
  if(!stats||!root.isConnected)return;
  const rating=stats.rating.toFixed(1).replace('.',','),count=new Intl.NumberFormat('fr-FR').format(stats.count);
  root.querySelectorAll('[data-review-rating]').forEach(el=>el.textContent=rating);
  root.querySelectorAll('[data-review-count]').forEach(el=>el.textContent=count);
  root.querySelectorAll('[data-review-word]').forEach(el=>el.textContent=ratingWord(stats.rating));
  root.querySelectorAll('[data-review-stars]').forEach(el=>{el.style.setProperty('--csr-fill',`${stats.rating/5*100}%`);el.setAttribute('aria-label',`Note : ${rating} sur 5`)});
  root.querySelectorAll('[data-review-score-panel]').forEach(el=>el.hidden=false);
  root.dataset.loaded='true';root.hidden=false;
}
function connectWithin(parent=document){
  if(parent.matches?.('[data-casame-aggregate]'))connectAggregate(parent);
  parent.querySelectorAll('[data-casame-aggregate]').forEach(connectAggregate);
}
if(typeof document!=='undefined'){
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>connectWithin(),{once:true});else connectWithin();
  document.addEventListener('shopify:section:load',e=>connectWithin(e.target));
  document.addEventListener('casame:photo-reviews-loaded',e=>{
    const badge=e.target.closest('.casame-home-reviews')?.querySelector('[data-verified-photos]');
    if(badge)badge.hidden=!e.detail.allVerified;
  });
}
